import { useEffect } from 'react';

export const useCerrarMenuAlClickFuera = (menuAbierto, setMenuAbierto) => {
  useEffect(() => {
    if (!menuAbierto) return;

    const handleClick = (e) => {
      if (!e.target.closest('aside') && !e.target.closest('.menu-toggle')) {
        setMenuAbierto(false);
      }
    };

    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [menuAbierto, setMenuAbierto]);
};
